import { useTranslations } from '@vocab/react';
import { Box, Heading, Stack, Text, TextLink } from 'braid-design-system';

import translations from '../.vocab';

import { ContactUsImage } from './ContactUsImage';

export const ContactPanel = () => {
  const { t } = useTranslations(translations);

  return (
    <Box position="relative" overflow="hidden">
      <Stack space="medium" align="center">
        <ContactUsImage />

        <Heading level="4" weight="regular" align="center">
          {t('contactUs')}
        </Heading>

        <Text size="standard" align="center" weight="regular" tone="secondary">
          {t('needHelpContactUs', {
            TextLink: (children) => (
              <TextLink href="/contactus" target="_blank" weight="weak">
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
    </Box>
  );
};
